module.exports = __webpack_public_path__ + "img/badge_incentive_info.8db1f78d.jpg";